<template>
  <!--  <table :style="{width:width+'px',height:height+'px'}" style="border-collapse: collapse;color: #fff;text-align: center;">
    <colgroup v-if="option.attribute.showIndex" style="width: 60px;"/>
    <colgroup v-for="(item) in option.attribute.columns" :key="item.colKey" :style="{width: item.width>0?item.width+'px':''}"/>
    <thead style="background-color: #001A59;"
           :style="{backgroundImage: 'linear-gradient('+option.attribute.theadBg.toString()+')',
           height: option.attribute.theadHeight+'px',color:option.attribute.theadColor,
           fontSize:option.attribute.theadSize+'px'}">
      <tr>
        <td v-if="option.attribute.showIndex">序号</td>
        <td v-for="(column) in option.attribute.columns" :key="column.colKey" :ref="column.colKey">{{column.title}}</td>
      </tr>
    </thead>
    <tbody is="transition-group" name="bounce" appear>
    <tr style="position: absolute;" v-for="(temp,index) in rollData" :key="temp.rowNum"
        :style="{width: width+'px',height: rowHeight+'px',marginTop: index * rowHeight+'px',
        backgroundColor: temp.rowNum % 2=== 0 ? option.attribute.oddRowBg:option.attribute.evenRowBg,
        color:option.attribute.tbodyColor,fontSize: option.attribute.tbodySize+'px'}">
      <td v-if="option.attribute.showIndex" style="width: 60px;" :style="{lineHeight:rowHeight+'px'}">{{temp.rowNum+1}}</td>
      <td v-for="(column) in option.attribute.columns" :key="column.colKey" :style="{width: colWidths[column.colKey]+'px'}">
        <div style="position: absolute;top: 50%;transform: translateY(-50%);width: 100%;overflow-x: hidden;white-space:nowrap" :style="{width: colWidths[column.colKey]+'px'}">
          <img v-if="column.type === 'img'" :src="fileUrl+ temp[column.colKey]"/>
          <span :title="temp[column.colKey]" v-else>{{temp[column.colKey]}}</span>
        </div>
      </td>
    </tr>
    </tbody>
  </table>-->
  <div :style="{
    width: width + 'px',
    height: height + 'px',
    '--border-color': option.attribute.borderColor,
  }" style="color: #fff; text-align: center">
    <!-- showTableHeaderComputed -->
    <!-- 表头 -->
    <div style="display: flex; box-sizing: border-box; cursor: pointer" :class="[
      option.attribute.borderType
        ? headerBorderClass[option.attribute.borderType]
        : '',
      showTableHeaderComputed ? '' : 'scroll-table-show-header',
    ]" :style="{
        backgroundImage: 'linear-gradient(' + theadBg + ')',
        lineHeight: option.attribute.theadHeight + 'px',
        color: option.attribute.theadColor,
        fontSize: option.attribute.theadSize + 'px',
        fontWeight: option.attribute.fontWeight,
      }">
      <div v-if="option.attribute.showIndex" style="width: 60px; box-sizing: border-box"
        :class="option.attribute.borderType === 'all' ? 'row-border-right' : ''">
        序号
      </div>
      <div v-for="column in option.attribute.columns" :key="column.colKey" :ref="column.colKey"
        :class="option.attribute.borderType === 'all' ? 'row-border-right' : ''"
        :style="column.width > 0 ? { width: column.width + 'px', 'text-align': column.textAlign } : { flexGrow: 1, 'text-align': column.textAlign }"
        @click="doSort(column)">
        {{ column.title }}
        {{
          column.colKey === sort.sortKey
            ? sort.sortType === 1
              ? "↑"
              : "↓"
            : ""
        }}
      </div>
    </div>
    <transition-group name="bounce" appear>
      <div style="position: absolute; display: flex; box-sizing: border-box" :class="option.attribute.borderType
          ? bodyBorderClass[option.attribute.borderType]
          : ''
        " v-for="(row, index) in rollData" :key="current.id + row.rowNum" :style="{
          width: width + 'px',
          height: rowHeight + 'px',
          lineHeight: rowHeight + 'px',
          marginTop: index * rowHeight + 'px',
          backgroundColor:
            currentIndex == index
              ? option.attribute.chooseRowBg
              : row.rowNum % 2 === 0
                ? option.attribute.oddRowBg
                : option.attribute.evenRowBg,
          fontSize: option.attribute.tbodySize + 'px',
          border:
            currentIndex == index
              ? '1px solid ' + option.attribute.chooseColor
              : 'none',
          cursor:
            option.interaction.eventList &&
              option.interaction.eventList.length > 0 &&
              option.interaction.eventList.some(
                (ritem) => ritem.tableActive == 'rowclick'
              )
              ? 'pointer'
              : '',
        }" @click="rowclickHandler(row, '', index)">
        <!-- @click="option.interaction.eventList && option.interaction.eventList.length > 0 && option.interaction.eventList.some((ritem) => ritem.tableActive == 'rowclick') && clickHandler(row,'',index)"> -->
        <div v-if="option.attribute.showIndex" style="width: 60px" :style="{
          lineHeight: rowHeight + 'px',
          color: option.attribute.tbodyColor,
        }" :class="option.attribute.borderType === 'all' ? 'row-border-right' : ''
            ">
          {{ row.rowNum + 1 }}
        </div>
        <div v-for="column in option.attribute.columns" :key="column.colKey" :style="{
          width: colWidthsComputed(column),
          'text-align': column.textAlign,
          cursor:
            option.interaction.eventList &&
              option.interaction.eventList.length > 0 &&
              option.interaction.eventList.some(
                (citem) => citem.tableActive == 'colclick'
              ) &&
              option.interaction.eventList.some(
                (citemkey) => citemkey.intNameId == column.colKey
              )
              ? 'pointer'
              : '',
        }" :class="option.attribute.borderType === 'all' ? 'row-border-right' : ''
            " @click="
            option.interaction.eventList &&
            option.interaction.eventList.length > 0 &&
            option.interaction.eventList.some(
              (citem) => citem.tableActive == 'colclick'
            ) &&
            option.interaction.eventList.some(
              (citemkey) => citemkey.intNameId == column.colKey
            ) &&
            rowclickHandler(row, column.colKey)
            ">
          <div style="
              position: absolute;
              width: 100%;
              overflow-x: hidden;
              white-space: nowrap;
            " :style="{
              width: colWidthsComputed(column),
              color:
                row.TBCONFIG_COLOR &&
                  row.TBCONFIG_FILED &&
                  row.TBCONFIG_FILED === column.colKey
                  ? row.TBCONFIG_COLOR
                  : rowTextColorComputed(column),
            }">
            <img class="btns" v-if="column.type === 'img'" @click.stop="btnclickHandler(row, index, column.colKey)"
              style="vertical-align: middle" :src="fileUrl + row[column.colKey]" />

            <span class="btns" :style="{
              ...enableGradualComputed(column),
            }" :title="row[column.colKey]" @click.stop="btnclickHandler(row, index, column.colKey)"
              v-else-if="column.type === 'btn'">{{ row[column.colKey] }}</span>
            <span :style="{
              ...enableGradualComputed(column),
            }" :title="row[column.colKey]" v-show="column.type !== 'btn' && column.type !== 'img'">{{
                row[column.colKey] }}</span>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";
import { fileUrl } from "/env";
export default {
  name: "cpt-scroll-table",
  props: {
    option: Object,
    width: Number,
    height: Number,
    current: Object,
    show: Boolean,
    components: Array,
  },
  watch: {
    "option.attribute.rowHeight": {
      handler() {
        this.computeRowHeight();
      },
      deep: true,
    },
    "option.attribute.showLine": {
      handler() {
        this.computeRowHeight();
        this.scrollTable();
        this.computeColWidth();
      },
      deep: true, //深度监听
    },
    width() {
      this.computeColWidth();
    },
    height() {
      this.computeRowHeight();
    },
    show: {
      handler(val) {
        console.log("valioajsdioasjiodaisjodijaosd", val);

        if (val) {
          this.computeColWidth();
        }
      },
      immediate: true,
    },
    "current.cptShow"(val) {
      console.log("text-show-", val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  data() {
    return {
      fileUrl,
      colWidths: {},
      rowHeight: 10,
      tableData: [],
      originTableData: [],
      rollData: [],
      cptData: "",
      currentIndex: null,
      uuid: null,
      timer: null,
      headerBorderClass: {
        none: "",
        button: "head-border-button",
        all: "head-border",
      },
      bodyBorderClass: {
        none: "",
        button: "row-border-button",
        all: "head-border",
      },
      sort: {
        sortKey: "",
        sortType: 1,
      },
    };
  },
  computed: {
    theadBg() {
      return (
        this.option.attribute.theadBg &&
        this.option.attribute.theadBg.toString()
      );
    },
    showTableHeaderComputed() {
      // 兼容处理
      if (this.option.attribute.hasOwnProperty("showTableHeader")) {
        return this.option.attribute.showTableHeader;
      } else {
        return true;
      }
    },
    // 字体颜色
    rowTextColorComputed() {
      return (column) => {
        if (!column.enableGradual) {
          return this.option.attribute.tbodyColor;
        }
        let isTextColor =
          column.enableGradual == 1
            ? column.textColor
              ? column.textColor
              : this.option.attribute.tbodyColor
            : "";
        console.log(isTextColor, "sadalpopdaoaosdodko");
        return isTextColor;
      };
    },
    // 字体渐变色
    enableGradualComputed() {
      return (column) => {
        let isGradual = [
          { value: 2, position: "right" },
          { value: 3, position: "bottom" },
        ].find((x) => x.value === column.enableGradual);
        if (isGradual) {
          return {
            "background-image": `linear-gradient(to ${isGradual.position
              }, ${column.gradualColor.toString()})`,
            "background-clip": "text",
            color: "transparent",
            fontWeight: column.fontWeight,
            fontFamily: column.textFamily,
          };
        }
      };
    },
    colWidthsComputed() {
      return (column) => {
        return column.width > 0
          ? column.width + "px"
          : this.colWidths[column.colKey] + "px";
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0];
    },
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0];
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
    console.log(this.option, "option");
  },
  mounted() {
    this.computeColWidth();
    this.computeRowHeight();
  },
  methods: {
    // 设置默认第几行
    setDefualtRowIndex() {
      const { defaultRowIndex } = this.option.attribute;
      this.currentIndex = defaultRowIndex > 0 ? defaultRowIndex - 1 : -1;
      if (this.rollData.length == 0) {
        return;
      }
      if (this.currentIndex === -1) {
        return;
      }
      this.rowclickHandler(
        this.rollData[this.currentIndex],
        "",
        this.currentIndex
      );
    },
    computeRowHeight() {
      const { rowHeight } = this.option.attribute;
      if (rowHeight > 0) {
        this.rowHeight = rowHeight;
      } else {
        this.rowHeight =
          (this.height - this.option.attribute.theadHeight) /
          this.option.attribute.showLine;
      }
    },
    computeColWidth() {
      const that = this;
      this.$nextTick(() => {
        that.colWidths = {};
        this.option.attribute.columns.forEach((item) => {
          let columnWidth = item.width
            ? item.width
            : that.$refs[item.colKey][0].clientWidth;
          that.colWidths[item.colKey] = columnWidth;
        });
      });
    },
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(
        this.uuid,
        cptDataForm,
        () => this.loadData(cptDataForm, paras),
        this.components
      );
    },
    loadData(cptDataForm, paras) {
      getDataJson(cptDataForm, paras, (res) => {
        console.log("biaoge", res, this.current.id);
        let parse = Array.isArray(res) ? res : res.resStr;
        for (let i = 0; i < parse.length; i++) {
          parse[i].rowNum = i;
        }
        this.tableData = parse;
        this.originTableData = parse;
        this.scrollTable();
        this.setDefualtRowIndex();
      });
    },
    setCurrent(index) {
      this.option.attribute.current = Math.floor(
        index / this.option.attribute.showLine
      );
    },
    scrollTable() {
      const that = this;
      console.log('qwdij0qwidqwidjwqidqwijiqwjdiowqjdijqdwijqo');
      if (this.timer) {
        clearInterval(this.timer);
      }
      that.rollData = that.tableData.slice(0, this.option.attribute.showLine);
      if (this.option.attribute.showLine >= that.tableData.length) {
        return;
      }
      let i = this.option.attribute.showLine;

      this.timer = setInterval(() => {
        that.rollData.shift();
        that.rollData.push(that.tableData[i]);
        // that.computeColWidth();
        i++;
        this.setCurrent(i);
        if (i >= that.tableData.length) {
          i = 0;
        }
      }, 2000);
    },
    doSort(column) {
      if (this.sort.sortType === 1 && this.sort.sortKey !== "") {
        this.sort.sortKey = "";
        this.tableData = this.originTableData;
        this.scrollTable();
        return;
      }
      this.sort.sortType = this.sort.sortType === 1 ? 2 : 1;
      this.sort.sortKey = column.colKey;
      if (this.sort.sortType === 1) {
        //排序
        this.tableData = this.sortBy(this.originTableData, column.colKey);
      } else {
        this.tableData = this.sortBy(
          this.originTableData,
          column.colKey
        ).reverse();
      }
      this.scrollTable();
    },
    sortBy(arr, k) {
      let newArr = JSON.parse(JSON.stringify(arr));
      return newArr.sort((a, b) => (a[k] > b[k] ? 1 : a[k] < b[k] ? -1 : 0));
    },
    rowclickHandler(item, key, index) {
      console.log(index, key, "clickHandlerindex");
      this.currentIndex = index;
      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        item,
        "cpt-scroll-table",
        key
      );
    },
    // colclickHandler(item, key, index) {
    //   console.log(index,key,'clickHandlerindex')
    //   this.currentIndex = index
    //   this.$emit("clickHandler", this.option.interaction, 'default', item, 'cpt-scroll-table', key)
    // },
    btnclickHandler(item, index, key) {
      console.log(index, "btnclickHandlerindex");

      // this.currentIndex = index
      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        item,
        "cpt-scroll-table",
        key
      );
    },
  },
  beforeUnmount() {
    // clearInterval(this.timer);
  },
};
</script>

<style scoped>
.head-border {
  border-left: 1px solid var(--border-color);
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.scroll-table-show-header {
  height: 0;
  overflow: hidden;
}

.head-border-button {
  border-bottom: 1px solid var(--border-color);
}

.row-border {
  border-bottom: 1px solid var(--border-color);
  border-left: 1px solid var(--border-color);
}

.row-border-button {
  border-bottom: 1px solid var(--border-color) !important;
}

.row-border-right {
  border-right: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.row-border-right:first-of-type {
  border-left: 1px solid var(--border-color);
}

.bounce-enter {
  transform: scaleY(0.5);
  transform-origin: 100% 100%;
}

.bounce-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.bounce-enter-active,
.bounce-leave-active {
  transition: all 0.5s;
}

.bounce-move {
  transition: transform 0.5s;
}

.btns {
  cursor: pointer;
}
</style>
